import translation from './translation.json';

const nl = {
    translation,
};

export default nl;
